// extracted by mini-css-extract-plugin
module.exports = {"add_form":"AddOtherName_add_form__2-hxL"};